import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { listProduct } from "../Redux/Actions/ProductActions";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Product from "../components/Product";
import Loader from "./../components/LoadingError/Loading";
import Message from "./../components/LoadingError/Error";

const PrintsScreen = () => {
  window.scrollTo(0, 0);
  const dispatch = useDispatch();

  const productList = useSelector((state) => state.productList);
  const { loading, error, products = [] } = productList;

  useEffect(() => {
    dispatch(listProduct("prints"));
  }, [dispatch]);

  return (
    <div>
      <Header />
      <div className="prints-intro">
        <h1 className="prints-title">Welcome to My Gallery!</h1>
        <p className="prints-description">
        Explore a vibrant collection of acrylic art that tells unique stories through each portrait. 
        Immerse yourself in meticulously crafted artworks bursting with color and texture. Whether you're 
        admiring, seeking inspiration, or looking for the perfect piece to add to your collection, 
        enjoy your journey through my gallery of creativity
        </p>
        <div className="prints-divider"></div>
      </div>
      {loading ? (
        <Loader />
      ) : error ? (
        <Message variant="danger">{error}</Message>
      ) : (
        <div className="gallery">
          {products.length > 0 ? (
            products.map((product) => (
              <Product key={product._id} product={product} />
            ))
          ) : (
            <p>No products available</p>
          )}
        </div>
      )}
      <Footer />
    </div>
  );
};

export default PrintsScreen;
